import { ComponentTypes } from "entities/template/lib/const/componentTypes";

const HIDDEN_DOCUMENT_FORM_COMPONENT_TYPES = new Set<ComponentTypes>([
    ComponentTypes.trackerIntegration,
    ComponentTypes.uuid,
    ComponentTypes.preview,
    ComponentTypes.language,
    ComponentTypes.autonumber,
    ComponentTypes.massDocGeneration
]);

const NON_EXTERNAL_FORM_COMPONENT_TYPES = new Set<ComponentTypes>([
    ComponentTypes.language,
    ComponentTypes.preview,
    ComponentTypes.uuid,
    ComponentTypes.massDocGeneration,
    ComponentTypes.trackerIntegration,
    ComponentTypes.autonumber
]);

export const TAG_SELECT_COMPONENT_TYPES = new Set<ComponentTypes>([
    ComponentTypes.checkbox,
    ComponentTypes.dateInput,
    ComponentTypes.file,
    ComponentTypes.input,
    ComponentTypes.money,
    ComponentTypes.inputWithSelect,
    ComponentTypes.multiline,
    ComponentTypes.radio,
    ComponentTypes.select,
    ComponentTypes.barcode,
    ComponentTypes.saveToExistingTicket,
    ComponentTypes.pdfPassword
]);

export const isDocumentFormComponent = (type: ComponentTypes): boolean =>
    !HIDDEN_DOCUMENT_FORM_COMPONENT_TYPES.has(type);

export const isExternalFormConfigurable = (type: ComponentTypes): boolean =>
    !NON_EXTERNAL_FORM_COMPONENT_TYPES.has(type);

export const isTagSelectComponent = (type: ComponentTypes): boolean =>
    TAG_SELECT_COMPONENT_TYPES.has(type);
